export const BIRTH_TIME_ACCURACY = {
  KNOWN: 'known',
  APPROXIMATE: 'approximate',
  UNKNOWN: 'unknown',
};

const VALID_ACCURACIES = new Set(Object.values(BIRTH_TIME_ACCURACY));

export function normalizeBirthTimeAccuracy(value) {
  if (VALID_ACCURACIES.has(value)) {
    return value;
  }
  return BIRTH_TIME_ACCURACY.KNOWN;
}

export function isUnknownBirthTime(accuracy) {
  return normalizeBirthTimeAccuracy(accuracy) === BIRTH_TIME_ACCURACY.UNKNOWN;
}
